var $ = require('jquery');

var BackTop = function BackTop() {
	if($('.back-top').length) {
		$('.back-top').click(function(e) {
			e.preventDefault();

			$('html,body').clearQueue().animate({
				scrollTop: 0
			});
		});
	}
}

module.exports = BackTop;